import { useTranslation } from 'react-i18next'
import { ContentLayout } from 'components/Layouts'
import { BreadCrumb } from 'components/BreadCrumb/BreadCrumb'
import { buildAbsoluteMedicareMyUrl } from 'utils/urls/buildAbsoluteMedicareMyUrl'
import { RelatedResources } from './RelatedResources'
import { FC } from 'react'
import { Component } from '@cms-max/medicare-api-sdk'

export interface ClaimsSubRouteLayoutProps {
  pageHeading: string
}

export const ClaimsSubRouteLayout : FC<ClaimsSubRouteLayoutProps> = ({ pageHeading, children }) => {
  const { t } = useTranslation('claimsSearch')
  return (
    <>
      <BreadCrumb
        backButtonText={t('navigation.backToMyClaims')}
        backButtonLink='/claims'
        navAriaLabel={t('navigation.backToClaimsMainPageAriaLabel')}
        width='wide'
        siteActivityProps={{
          core: {
            component: Component.Claims,
            coreClickData: {
              linkText: t('navigation.backToMyClaims'),
              linkUrl: buildAbsoluteMedicareMyUrl('/claims')
            },
            elementId: 'claims_backtosearch_click'
          }
        }}
      />
      <ContentLayout className='ds-u-padding-bottom--7' heading={pageHeading} width='wide' withPrintButton>
        {children}
        <RelatedResources />
      </ContentLayout>
    </>
  )
}
